import { GET_PAYMENT_PACKAGE_STATES } from "..";
import { apiInstance } from "../config/apiInstance";

export type PaymentPackageState = {
  id: number;
  code: string;
  name: string;
};

export const getPaymentPackageStates = async (): Promise<PaymentPackageState[]> => {
  const response = await apiInstance.get<PaymentPackageState[]>(
    GET_PAYMENT_PACKAGE_STATES
  );
  return response.data;
};
